import { retrieveErrorAndDescription } from '../../../backend/routes/api-errors'
import { RATE_LIMITING } from '../../../fauna/src/rate-limiting'
import { faunaAPI } from './fauna-api'

export const handleChangePasswordError = (err) => {
  const codeAndDescription = retrieveErrorAndDescription(err)
  console.log(codeAndDescription)
  if (codeAndDescription && codeAndDescription.description.includes('Invalid password')) {
    return "Invalid password.";
  } else {
    console.error(err)
    return "Oops something went wrong"
  }
}

export const handleLoadingError = (err) => {
  const errorAndCode = retrieveErrorAndDescription(err)
  if (errorAndCode.code === 'unauthorized') {
    return "Verification token no longer valid"
  } else {
    return err.description
  }
}


export const handleDataLoadingError = (err, loggedIn) => {
  const errorAndCode = retrieveErrorAndDescription(err);
  if (err.requestResult && err.requestResult.responseContent) {
    let error = err.requestResult.responseContent.errors;
    error = JSON.stringify(error);
    console.log(error);
  }
  if (errorAndCode && errorAndCode.code === 'transaction aborted') {
    if (errorAndCode.description === RATE_LIMITING) {
      return "Rate limiting"
    } else {
      return err.description;
    }
  } else if (errorAndCode && errorAndCode.code === 'unauthorized') {
    if (loggedIn) {
      // Make sure to reset httpOnly cookie.
      faunaAPI.logout()
      return "You have been logged out"
    } else {
      return err.description
    }
  } else {
    return err.description;
  }
}
